import React, { FC } from 'react';
import styled from 'styled-components';
import { PatchStatus } from '../../../constants';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

type PatchStatusMessageProps = {
  title?: string;
  hoverActive: boolean;
  status: PatchStatus;
};

const Wrapper = styled(({ hoverActive, ...restProps }) => <div {...restProps} />)`
  position: absolute;
  background: ${({ hoverActive }) => (hoverActive ? '#ffffff' : 'transparent')};
  padding: ${({ hoverActive }) => (hoverActive ? '0.6rem 1rem' : '.4rem 0')};
  top: -1.9rem;
  left: ${({ hoverActive }) => (hoverActive ? '-2rem' : '0')};
  transform: translateY(-50%);
  font-size: 1.4rem;
  box-shadow: ${({ hoverActive, theme }) =>
    hoverActive ? `0 0 1rem -0.2rem ${theme.palette.grey['400']}` : 'none'};
  color: ${({ theme }) => theme.palette.grey['900']};
`;

const BlockTitle = styled('span')({
  marginRight: '1rem',
});

const Label = styled(({ status, ...restProps }) => <span {...restProps} />)`
  position: relative;
  font-size: 1.4rem;
  color: ${({ theme, status }) =>
    status === PatchStatus.SUCCESS ? theme.palette.success.main : theme.palette.error.main};
  padding-left: 2rem;
`;

const StatusIcon = styled(FontAwesomeSpriteIcon)({
  position: 'absolute',
  top: '50%',
  left: 0,
  transform: 'translateY(-50%)',
});

export const PatchStatusMessage: FC<PatchStatusMessageProps> = ({ title, hoverActive, status }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (status === PatchStatus.INITIAL) return null;

  return (
    <Wrapper hoverActive={hoverActive}>
      {hoverActive && title != null && <BlockTitle>{title}:</BlockTitle>}
      <Label status={status}>
        <StatusIcon
          icon={status === PatchStatus.SUCCESS ? SpriteIconsLight.SUBMIT : SpriteIconsLight.ERROR}
          iconSize="sm"
          color={
            status === PatchStatus.SUCCESS ? theme.palette.success.main : theme.palette.error.main
          }
        />
        {status === PatchStatus.SUCCESS ? t('froala.autoSave.success') : t('froala.autoSave.error')}
      </Label>
    </Wrapper>
  );
};
